





















import { Component, Vue } from 'vue-property-decorator'
import { FillInfoItemOfForm, OperationItemType } from '@/types/type'
import { getAllFatherNodeForTree, findItemForTree } from '@/utils/toolsForCommon'
import { CommonModule, UserModule, CanteenModule } from '@/store'
import DateUtil from '@/utils/toolsForDate'
@Component({
  name: 'AddOrUpdateCanteenInventory',
  components: {
    'form-module': () => import('../../components/common/formModule.vue')
  }
})
export default class AddOrUpdateCanteenInventory extends Vue {
  public loading = false
  public headerOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  public bottomOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: `保存`,
      key: 'save',
      type: 'success',
      size: ''
    }
  ]
  public fillInfoList: Array<FillInfoItemOfForm> = [
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationName',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      schoolItem: {},
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '入/出库时间',
      type: 'dateForDate',
      key: 'createdTime',
      value: '',
      placeholder: '请选择入/出库时间',
      isNecessary: true
    },
    {
      title: '科目',
      type: 'cascaderForcode',
      key: 'subject',
      value: '',
      placeholder: '请选择科目',
      treeData: [],
      treeItem: {},
      isNecessary: true,
      filterable: true
    },
    {
      title: '商品名称',
      type: 'text',
      key: 'goodName',
      value: '',
      placeholder: '请输入商品名称',
      isNecessary: true
    },
    {
      title: '金额（元）',
      type: 'number',
      key: 'money',
      value: '',
      placeholder: '请输入金额',
      isNecessary: true
    },
    {
      title: '数量',
      type: 'number',
      key: 'amount',
      value: '',
      placeholder: '请输入数量',
      isNecessary: true
    },
    {
      title: '单位',
      type: 'text',
      key: 'unit',
      value: '',
      placeholder: '请输入单位',
      isNecessary: true,
      explainText: '选择科目会自动补全单位'
    },
    {
      title: '生产日期',
      type: 'dateForDate',
      key: 'manufactureDate',
      value: '',
      placeholder: '请选择生产日期',
      isNecessary: true
    },
    {
      title: '保质期（天）',
      type: 'number',
      key: 'expirationDay',
      value: '',
      placeholder: '请输入保质期',
      isNecessary: true
    },
    {
      title: '品牌',
      type: 'text',
      key: 'brand',
      value: '',
      placeholder: '请输入品牌',
      isNecessary: true
    },
    {
      title: '条码',
      type: 'photo',
      key: 'code',
      value: '',
      placeholder: '请上传条码',
      isNecessary: true
    },
    {
      title: '生产厂家',
      type: 'text',
      key: 'manufactureFactory',
      value: '',
      placeholder: '请输入生产厂家',
      isNecessary: true
    },
    {
      title: '入/出库单据',
      type: 'photo',
      key: 'voucher',
      value: '',
      placeholder: '请上传入/出库单据',
      isNecessary: true
    },
    {
      title: '备注',
      type: 'textarea',
      key: 'comment',
      value: '',
      placeholder: '请输入备注',
      isNecessary: false
    }
  ]
  public subjectUnitList: any[] = []
  public subjectUnitMap: Map<string, string> = new Map()

  // 新增编辑的文字展示
  get addOrUpdateTitle (): string {
    const { id, inOrOut } = this.$route.query
    let inOrOutText = ''
    switch (inOrOut) {
      case '0':
        inOrOutText = '入库'
        break
      case '1':
        inOrOutText = '出库'
        break
    }
    let res: string = '新增'
    if (id && id !== 'add') {
      res = '编辑'
    }
    return `${res}${inOrOutText}`
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async created () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject(),
      this.getCanteenCommonQuerySubjectUnit()
    ])
    this.disposeForFillInfoList()
    let { id } = (this as any).$route.query
    if (!id) return (this as any).$router.go(-1)
  }

  // 选择框数据处理
  disposeForFillInfoList () {
    const { inOrOut, orgId, subject } = this.$route.query
    let inOrOutText = ''
    switch (inOrOut) {
      case '0':
        inOrOutText = '入库'
        break
      case '1':
        inOrOutText = '出库'
        break
    }
    this.fillInfoList = this.fillInfoList.map(item => {
      switch (item.key) {
        case 'createdTime':
          item.title = `${inOrOutText}时间`
          item.placeholder = `请选择${inOrOutText}时间`
          item.value = DateUtil.getNowDay()
          break
        case 'voucher':
          item.title = `${inOrOutText}单据`
          item.placeholder = `请上传${inOrOutText}单据`
          break
        case 'organizationName':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          if (orgId) {
            item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', Number(orgId))
            item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', Number(orgId))
          }
          break
        case 'subject':
          item.treeData = this.treeDataForDisposeNameSubject
          if (subject) {
            item.value = getAllFatherNodeForTree(this.treeDataForDisposeNameSubject, 'children', 'code', subject)
          }
          break
      }
      return item
    })
  }

  getCascaderForcodeChange (event, item): void {
    let { key, value } = item
    if (key === 'subject') {
      this.fillInfoList = this.fillInfoList.map(v => {
        if (v.key === 'unit') {
          if (value.length) {
            const res = value[value.length - 1]
            if (this.subjectUnitMap.has(res)) {
              v.value = this.subjectUnitMap.get(res)
            } else {
              v.value = ''
            }
          }
        }
        return v
      })
    }
  }

  async saveAll (continuousValue) {
    try {
      let whoEmpty = null
      let isEmpty = this.fillInfoList.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      let params = this.fillInfoList.reduce((result, current) => {
        const { key, value } = current
        switch (key) {
          case 'organizationName':
            let { name, id } = current.temporaryStorageForValue
            result['orgName'] = name
            result['orgId'] = id
            break
          case 'subject':
            result[key] = value[(value || []).length - 1]
            break
          default:
            result[key] = value
            break
        }
        return result
      }, {})
      let { id, inOrOut } = this.$route.query
      Object.assign(params, {
        outOrIn: inOrOut === '1' ? true : false
      })
      if (id && id !== 'add') {
        Object.assign(params, { id })
      }
      const { data: result } = await (this as any).$http.inventorySave(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(`${this.addOrUpdateTitle}成功`)
      setTimeout(() => {
        if (continuousValue) {
          const { id, inOrOut, orgId, subject } = this.$route.query
          const query = {
            id,
            inOrOut
          }
          if (orgId) {
            Object.assign(query, {
              orgId
            })
          }
          if (subject) {
            Object.assign(query, {
              subject
            })
          }
          this.$router.replace({ name: 'AddOrUpdateCanteenInventory', query }, () => {
            window.location.reload()
          })
        } else {
          this.$router.go(-1)
        }
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  getFormResultFromChild (result) {
    let { key, value } = result
    this.fillInfoList.forEach(item => {
      if (item.key === key) {
        switch (key) {
          // 学校：
          case 'organizationName':
            item.temporaryStorageForValue = value
            break
          default:
            item.value = value
            break
        }
      }
    })
  }

  async getCanteenCommonQuerySubjectUnit () {
    try {
      const { data: result } = await (this as any).$http.canteenCommonQuerySubjectUnit()
      if (result.code !== 200) return this.$message.error(result.msg)
      this.subjectUnitList = result.data
      this.subjectUnitList.forEach(item => {
        let { subject, unit } = item
        this.subjectUnitMap.set(subject, unit)
      })
    } catch (err) {
      console.log(err)
    }
  }

  operationForButton ({ key }) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
      case 'save':
        this.saveAll((this as any).$refs.refOfFormModule.continuousValue)
        break
    }
  }
}
